/**
 * Shown when a customer-facing page cannot determine which branch it belongs
 * to (no ?branch=<code> in the URL and no logged-in device). Replaces the old
 * behavior of silently falling back to branch 1.
 */
import React from "react";
import { Box, Typography, Alert, CircularProgress } from "@mui/material";

export const BranchLoading = () => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        px={2}
        sx={{ mt: { xs: 10, sm: 14 } }}
    >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
            Laster...
        </Typography>
    </Box>
);

const BranchNotFound = () => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        px={2}
        sx={{ mt: { xs: 10, sm: 14 } }}
    >
        <Alert severity="error" sx={{ maxWidth: 480 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }} mb={1}>
                Ugyldig lenke
            </Typography>
            <Typography variant="body2">
                Denne siden er ikke knyttet til en butikk. Skann QR-koden i
                butikken på nytt, eller kontakt personalet for riktig lenke.
            </Typography>
        </Alert>
    </Box>
);

export default BranchNotFound;
